import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

import TopToolbar from '../../global/subcomponents/topToolbar/TopToolbar';
import withShipment from '../../../withShipment';
import { viewOnlySelector } from '../../../redux/selectors/auth';
import { INK, GREEN, RED, MUTED, CANVAS, CARD_SHADOW } from './tokens';
import { scheduleSummary } from './bonusSchedule';
import { Switch } from './bonusUi';

class BonusList extends React.Component {
  render() {
    const {
      bonuses,
      onOpen,
      onNew,
      onToggle,
      onDownloadPdf,
      viewOnly,
    } = this.props;
    const list = bonuses || [];
    const activeCount = list.filter((b) => b.enabled).length;
    const inactiveCount = list.length - activeCount;

    const menuItems = [
      { title: 'Add Bonus', icon: <AddCircleIcon />, onClick: onNew },
      { title: 'Download PDF', icon: <PictureAsPdfIcon />, onClick: onDownloadPdf },
    ];

    return (
      <div className="nds-bonus" style={{ background: CANVAS, minHeight: '100%' }}>
        <TopToolbar pageName="Bonus Management" menuItems={menuItems} />

        <div className="nds-bonus-page">
          {/* Status summary */}
          <div
            style={{
              borderRadius: 24,
              background: '#fff',
              boxShadow: CARD_SHADOW,
              padding: '16px 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: 12,
            }}
          >
            <div>
              <p style={{ fontSize: 32, fontWeight: 800, lineHeight: 1, margin: 0, color: INK }}>
                {activeCount}
                <span style={{ fontSize: 18, fontWeight: 700, color: MUTED }}>
                  {' '}
                  / {list.length}
                </span>
              </p>
              <p style={{ fontSize: 13, fontWeight: 700, color: GREEN, margin: '6px 0 0' }}>
                Active right now
              </p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <p style={{ fontSize: 32, fontWeight: 800, lineHeight: 1, margin: 0, color: INK }}>
                {inactiveCount}
              </p>
              <p style={{ fontSize: 13, fontWeight: 700, color: RED, margin: '6px 0 0' }}>
                Inactive
              </p>
            </div>
          </div>

          {list.length === 0 && (
            <div
              style={{
                borderRadius: 24,
                background: '#fff',
                boxShadow: CARD_SHADOW,
                padding: '32px 20px',
                textAlign: 'center',
                color: MUTED,
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              No bonuses yet. Tap the amber + to create one.
            </div>
          )}

          {/* Rows */}
          <div className="nds-bonus-list-grid">
            {list.map((b) => {
              // Anyone who can reach this screen holds the manage-bonus
              // permission, so every row is editable except at a VIEW-ONLY
              // location, where the toggle is simply dropped.
              // See constants/readOnlyAccess.js.
              const editable = !viewOnly;
              return (
                <div
                  key={b.manageBonusId}
                  style={{
                    borderRadius: 24,
                    background: '#fff',
                    boxShadow: CARD_SHADOW,
                    padding: '14px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                  }}
                >
                  <button
                    type="button"
                    onClick={() => onOpen(b)}
                    style={{
                      flex: 1,
                      minWidth: 0,
                      textAlign: 'left',
                      border: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      padding: 0,
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span
                        style={{
                          width: 10,
                          height: 10,
                          flex: '0 0 10px',
                          borderRadius: '50%',
                          background: b.enabled ? GREEN : RED,
                          boxShadow: `0 0 0 3px ${
                            b.enabled ? 'rgba(22,163,74,0.15)' : 'rgba(220,38,38,0.15)'
                          }`,
                        }}
                      />
                      <p
                        style={{
                          fontSize: 15,
                          fontWeight: 700,
                          margin: 0,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          color: b.enabled ? INK : MUTED,
                        }}
                      >
                        {b.name}
                      </p>
                    </div>
                    <p
                      style={{
                        fontSize: 12,
                        margin: '2px 0 0',
                        paddingLeft: 18,
                        fontWeight: 500,
                        color: MUTED,
                      }}
                    >
                      <span style={{ fontWeight: 700, color: b.enabled ? GREEN : RED }}>
                        {b.enabled ? 'Active' : 'Inactive'}
                      </span>{' '}
                      · {scheduleSummary(b)} · {(b.specifications || []).length} payout
                      {(b.specifications || []).length === 1 ? '' : 's'}
                    </p>
                  </button>

                  {editable && (
                    <Switch on={b.enabled} onChange={() => onToggle(b, !b.enabled)} />
                  )}
                  <button
                    type="button"
                    onClick={() => onOpen(b)}
                    style={{
                      border: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      color: MUTED,
                      display: 'flex',
                      padding: 0,
                    }}
                  >
                    <ChevronRightIcon style={{ fontSize: 20 }} />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  viewOnly: viewOnlySelector(state),
});

export default withShipment({ mapStateToProps, actionCreators: {} }, BonusList);
